module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyrightPage"
  }, [_c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("This edition of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Immelmann: The Eagle of Lille")]), _vm._v(" is published in the United States of America in 2009 by"), _c('br'), _vm._v("\n    CASEMATE"), _c('br'), _vm._v("\n    908 Darby Road, Havertown, PA 19083")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("and in the United Kingdom by"), _c('br'), _vm._v("\n    CASEMATE"), _c('br'), _vm._v("\n    17 Cheap Street, Newbury, RG14 5DD")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_c('img', {
    staticClass: "greenhill",
    attrs: {
      "alt": "",
      "src": "Images/9781935149767_pic0002.png"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Greenhill Book")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Copyright © 1990 & 2009 Lionel Leventhal Ltd")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Appendix © Norman L. Franks 1990")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Typeset & design © Casemate Publishers 2009")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("ISBN 978-1-935149-76-7 / 978-1-932033-98-4")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Cataloging in publication data is available from the"), _c('br'), _vm._v("\n    Library of Congress and the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording or otherwise without the prior permission of the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Printed and bound in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Publishing History:"), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Immelmann, The Eagle of Lille")]), _vm._v(" was first published in German as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("der Adler von Lille")]), _vm._v(" by K.F. Koehler Verlag, Leipzig in 1934. The first English edition was published by John Hamilton in 1935 or 1936. It was reissued in facsmile by Greenhill Books / Lionel Leventhal Ltd in 1990 with a new appendix by Norman Franks. This new edition has been completely retypeset but the original language has been left unaltered.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 63
// module chunks = 0